import { FluxStandardRoutingAction } from '@respond-framework/types';
import { SaasSubscriptionDetailsTabName } from './Wasabi/saasSubscriptions/constants';
import { Region as FeaturedInstitutionsRegion } from '../web/containers/WasabiPage/marketing/FeaturedInstitutions/types';
import { CursorPageSize } from '../web/components/Pagination/types';
import { TabOptionTypes } from '../web/containers/SubscriptionsAdmin/types';
import {
  ShareData,
  ShareType,
  UserData,
} from '../native/containers/ShareDetail/types';
import { ImMap } from './helpers/ImmutableTypes';
import { FeedItemContext } from './FeedItems/types';
import { ImPostMap } from './Posts/types';
import { ShareTextWidgetAppData } from '../native/components/NativeWidget/ShareWidget/types';

interface OlRoutingAction extends FluxStandardRoutingAction {
  state?: {
    institutionPrefix?: string;
  };
}

export const ROUTE_WASABI_PORTFOLIO_INSTITUTIONS =
  'ROUTE_WASABI_PORTFOLIO_INSTITUTIONS';
export const ROUTE_INSTITUTION_HOMEPAGE = 'ROUTE_INSTITUTION_HOMEPAGE';
export interface RouteInstitutionHomepage extends OlRoutingAction {
  type: 'ROUTE_INSTITUTION_HOMEPAGE';
  state: {
    institutionPrefix: string;
  };
}
export const ROUTE_MARKETING_PAGE = 'ROUTE_MARKETING_PAGE';
export const ROUTE_CONTACT_PAGE = 'ROUTE_CONTACT_PAGE';
export interface RouteContactPage extends OlRoutingAction {
  type: 'ROUTE_CONTACT_PAGE';
}

export const ROUTE_INSTITUTION_ADMIN_SETTINGS =
  'ROUTE_INSTITUTION_ADMIN_SETTINGS';

export interface RouteInstitutionAdminSettings extends OlRoutingAction {
  type: typeof ROUTE_INSTITUTION_ADMIN_SETTINGS;
  params: {
    sectionId?: 'team';
  };
}

export const ROUTE_INSTITUTION_ADMIN = 'ROUTE_INSTITUTION_ADMIN';
export interface RouteInstitutionAdmin extends OlRoutingAction {
  type: 'ROUTE_INSTITUTION_ADMIN';
  query: {
    institution: string;
    action?: string;
  };
}
export const ROUTE_INSTITUTION_PAGE = 'ROUTE_INSTITUTION_PAGE';

export const ROUTE_PARTNERS_LISTING_PAGE = 'ROUTE_PARTNERS_LISTING_PAGE';
export interface RoutePartnersListingPage extends OlRoutingAction {
  type: 'ROUTE_PARTNERS_LISTING_PAGE';
}

export const ROUTE_HOMEPAGE = 'ROUTE_HOMEPAGE';
export interface RouteHomepage extends OlRoutingAction {
  type: 'ROUTE_HOMEPAGE';
}
export const ROUTE_USER_PROFILE_PAGE = 'ROUTE_USER_PROFILE_PAGE';
export interface RouteUserProfilePage extends OlRoutingAction {
  type: 'ROUTE_USER_PROFILE_PAGE';
  params: {
    profileName: string;
    page?: string;
  };
}
export const ROUTE_USER_PROFILE_PAGE_BLOG = 'ROUTE_USER_PROFILE_PAGE_BLOG';
export const ROUTE_ACCOUNTS_LOGIN = 'ROUTE_ACCOUNTS_LOGIN';
export const ROUTE_ACCOUNTS_SIGNUP = 'ROUTE_ACCOUNTS_SIGNUP';
export const ROUTE_ACCOUNTS_SUBSCRIPTIONS = 'ROUTE_ACCOUNTS_SUBSCRIPTIONS';
export interface RouteAccountsSubscriptions extends OlRoutingAction {
  type: 'ROUTE_ACCOUNTS_SUBSCRIPTIONS';
  query?: {
    subscriptionId?: string;
    view?: TabOptionTypes;
  };
}
export const ROUTE_ACCOUNTS_UNKNOWN = 'ROUTE_ACCOUNTS_UNKNOWN';
export const ROUTE_ACCOUNTS_SETTINGS = 'ROUTE_ACCOUNTS_SETTINGS';
export interface RouteAccountSettings extends OlRoutingAction {
  type: 'ROUTE_ACCOUNTS_SETTINGS';
}
export const ROUTE_ACCOUNTS_NOTIFICATIONS = 'ROUTE_ACCOUNTS_NOTIFICATIONS';
export const ROUTE_OTHER_PAGE = 'ROUTE_OTHER_PAGE';
export interface RouteOther extends OlRoutingAction {
  type: 'ROUTE_OTHER_PAGE';
  params: {
    prefix: string;
    subPath?: string;
  };
  query?: {
    redirect: string;
  };
}
export const ROUTE_SSR_TEST = 'ROUTE_SSR_TEST';
export const ROUTE_BLOCKPAGE_CONTENT = 'ROUTE_BLOCKPAGE_CONTENT';
export const ROUTE_BLOCK_WIDGET = 'ROUTE_BLOCK_WIDGET';
export const ROUTE_RICH_TEXT_WIDGET = 'ROUTE_RICH_TEXT_WIDGET';
export interface RouteBlockWidget extends OlRoutingAction {
  type: string;
  params: {
    blockId: string;
  };
  query: {
    path: string;
    cohortPath: string;
  };
}
export const ROUTE_COURSES = 'ROUTE_COURSES';
export interface RouteCourses extends OlRoutingAction {
  type: 'ROUTE_COURSES';
}
export const ROUTE_COURSE_SPECIAL_PAGE = 'ROUTE_COURSE_SPECIAL_PAGE';
export const ROUTE_COURSE_ADMIN = 'ROUTE_COURSE_ADMIN';
export interface RouteCourseAdmin extends OlRoutingAction {
  type: 'ROUTE_COURSE_ADMIN';
  query: {
    moduleSet?: string;
    course: string;
  };
}

export type RouteCourseAdminQueryParams = {
  action: 'general';
  course: string;
  cohort: string;
};

export type PaginationRouteParams = {
  pageSize?: CursorPageSize;
  cursor?: string | null;
  filter?: string;
};

export interface RouteCourseAdminGeneral extends OlRoutingAction {
  type: 'ROUTE_COURSE_ADMIN';
  query: RouteCourseAdminQueryParams & PaginationRouteParams;
}

export const ROUTE_COHORT_ADMIN = 'ROUTE_COHORT_ADMIN';
export interface RouteCohortAdmin extends OlRoutingAction {
  type: 'ROUTE_COHORT_ADMIN';
  query: {
    moduleSet?: string;
    course: string;
    cohort?: string;
    action?: string;
  };
}
export const ROUTE_COURSE_ASSESSMENT = 'ROUTE_COURSE_ASSESSMENT';
export interface RouteCourseAssessment extends OlRoutingAction {
  type: 'ROUTE_COURSE_ASSESSMENT';
  query: {
    moduleSet?: string;
    course: string;
  };
}
export const ROUTE_COURSE_CERTIFICATION = 'ROUTE_COURSE_CERTIFICATION';
export interface RouteCourseCertification extends OlRoutingAction {
  type: 'ROUTE_COURSE_CERTIFICATION';
  query: {
    moduleSet?: string;
    course: string;
  };
}
export const ROUTE_COURSE_PROGRESS = 'ROUTE_COURSE_PROGRESS';
export interface RouteCourseProgress extends OlRoutingAction {
  type: 'ROUTE_COURSE_PROGRESS';
  query: {
    moduleSet?: string;
    course: string;
  };
}
export const ROUTE_COURSE_PAGE = 'ROUTE_COURSE_PAGE';
export interface RouteCoursePage extends OlRoutingAction {
  type: 'ROUTE_COURSE_PAGE';
  params: {
    institutionPrefix?: string;
    courseCode: string;
    subPath?: string;
  };
  query: {
    moduleSet?: string;
    inCohort?: string;
  };
  state: {
    institutionPrefix?: string;
  };
}
export const ROUTE_WASABI_HOME = 'ROUTE_WASABI_HOME';
export const ROUTE_WASABI_COURSE_LIST = 'ROUTE_WASABI_COURSE_LIST';
export const ROUTE_WASABI_COURSE_INFO = 'ROUTE_WASABI_COURSE_INFO';
export interface RouteWasabiCourseInfo extends OlRoutingAction {
  type: 'ROUTE_WASABI_COURSE_INFO';
  params: {
    courseId: string;
  };
}
export const ROUTE_WASABI_INSTITUTION_LIST = 'ROUTE_WASABI_INSTITUTION_LIST';
export const ROUTE_WASABI_INSTITUTION_INFO = 'ROUTE_WASABI_INSTITUTION_INFO';

export interface RouteWasabiInstitutionInfo extends OlRoutingAction {
  type: 'ROUTE_WASABI_INSTITUTION_INFO';
  params: {
    institutionId: string;
  };
}

export const ROUTE_WASABI_USER_LIST = 'ROUTE_WASABI_USER_LIST';
export const ROUTE_WASABI_USER_INFO = 'ROUTE_WASABI_USER_INFO';
export const ROUTE_WASABI_EMAIL_TEMPLATES = 'ROUTE_WASABI_EMAIL_TEMPLATES';
export const ROUTE_WASABI_PAYMENTS = 'ROUTE_WASABI_PAYMENTS';
export const ROUTE_WASABI_TERMS_OF_SERVICE = 'ROUTE_WASABI_TERMS_OF_SERVICE';
export const ROUTE_WASABI_SUBSCRIPTIONS = 'ROUTE_WASABI_SUBSCRIPTIONS';
export const ROUTE_WASABI_SAAS = 'ROUTE_WASABI_SAAS';
export const ROUTE_WASABI_SAAS_CREATE_SUBSCRIPTION =
  'ROUTE_WASABI_SAAS_CREATE_SUBSCRIPTION';

export const ROUTE_WASABI_SAAS_EDIT_SUBSCRIPTION =
  'ROUTE_WASABI_SAAS_EDIT_SUBSCRIPTION';
export interface RouteWasabiEditSubscription extends OlRoutingAction {
  type: 'ROUTE_WASABI_SAAS_EDIT_SUBSCRIPTION';
  params: {
    subscriptionId: string;
  };
}

export interface RouteWasabiCreateSubscription extends OlRoutingAction {
  type: 'ROUTE_WASABI_SAAS_CREATE_SUBSCRIPTION';
}

export const ROUTE_WASABI_SAAS_SUBSCRIPTION_INFO =
  'ROUTE_WASABI_SAAS_SUBSCRIPTION_INFO';
export interface RouteWasabiSubscriptionInfo extends OlRoutingAction {
  type: 'ROUTE_WASABI_SAAS_SUBSCRIPTION_INFO';
  params: {
    subscriptionId: string;
    tabName?: SaasSubscriptionDetailsTabName;
  };
}

export interface RouteWasabiUserInfo extends OlRoutingAction {
  type: 'ROUTE_WASABI_USER_INFO';
  params: {
    userId: string;
    tabName?: 'subscriptions' | 'courses' | 'institutions';
  };
}

export const ROUTE_WASABI_FEATURED_COURSES = 'ROUTE_WASABI_FEATURED_COURSES';
export const ROUTE_WASABI_FEATURED_INSTITUTIONS =
  'ROUTE_WASABI_FEATURED_INSTITUTIONS';

export interface RouteWasabiFeaturedInstitutions extends OlRoutingAction {
  type: 'ROUTE_WASABI_FEATURED_INSTITUTIONS';
  params: {
    tabName?: FeaturedInstitutionsRegion;
  };
}

export type RouteWasabi =
  | RouteWasabiInstitutionInfo
  | RouteWasabiCourseInfo
  | RouteWasabiUserInfo
  | RouteWasabiSubscriptionInfo
  | RouteWasabiFeaturedInstitutions
  | RouteWasabiCreateSubscription;

export const ROUTE_SSO = 'ROUTE_SSO';
export interface RouteSSO extends OlRoutingAction {
  type: 'ROUTE_SSO';
  params: {
    action: string;
  };
  query?: {
    url: string;
  };
}
export const ROUTE_INSTITUTION_QUALIFICATION_PAGE =
  'ROUTE_INSTITUTION_QUALIFICATION_PAGE';
export const ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE =
  'ROUTE_INSTITUTION_SUBSCRIPTIONS_PAGE';
export const ROUTE_PAYMENT_DETAILS_PAGE = 'ROUTE_PAYMENT_DETAILS_PAGE';
export const ROUTE_PAYMENT_THANKYOU_PAGE = 'ROUTE_PAYMENT_THANKYOU_PAGE';
export interface RoutePaymentThankyouPage extends OlRoutingAction {
  type: 'ROUTE_PAYMENT_THANKYOU_PAGE';
  query: {
    // eslint-disable-next-line camelcase
    payment_transaction_id: string;
  };
}
export const ROUTE_PAYMENT_OTHER_PAGE = 'ROUTE_PAYMENT_OTHER_PAGE';
export const ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE =
  'ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE';
export const ROUTE_MY_COURSES_PAGE = 'ROUTE_MY_COURSES_PAGE';
export interface RouteMyCoursePage extends OlRoutingAction {
  type: 'ROUTE_MY_COURSES_PAGE';
}

// SAML
export const ROUTE_SAML_COHORT_ENTRY_PAGE = 'ROUTE_SAML_COHORT_ENTRY_PAGE';
export interface RourteSamlCohortEntry extends OlRoutingAction {
  type: 'ROUTE_SAML_COHORT_ENTRY_PAGE';
}

export const ROUTE_CREATE_COURSE_PAGE = 'ROUTE_CREATE_COURSE_PAGE';
export interface RouteCreateCoursePage extends OlRoutingAction {
  type: 'ROUTE_CREATE_COURSE_PAGE';
}

export const ROUTE_CREATE_INSTITUTION_PAGE = 'ROUTE_CREATE_INSTITUTION_PAGE';
export interface RouteCreateInstitutionPage extends OlRoutingAction {
  type: 'ROUTE_CREATE_INSTITUTION_PAGE';
}

export const ROUTE_CERTIFICATE_VERIFICATION_PAGE =
  'ROUTE_CERTIFICATE_VERIFICATION_PAGE';

export interface RouteCertificateVerificationPage extends OlRoutingAction {
  type: 'ROUTE_CERTIFICATE_VERIFICATION_PAGE';
}

// ANDROID BACK
export const WARN_AND_MAYBE_EXIT_APP = 'WARN_AND_MAYBE_EXIT_APP';

// NAVIGATE
export const ACTIVITY_FEED = 'ACTIVITY_FEED';
export const COURSE_LANDING = 'COURSE_LANDING';
export const COURSE_PROGRESS = 'COURSE_PROGRESS';
export const COURSE_ASSESSMENT = 'COURSE_ASSESSMENT';
export const POST_DETAILS = 'POST_DETAILS';
export const MY_DRAWER_STACK_SCREEN = 'MY_DRAWER_STACK_SCREEN';

// COMMON
export const WEBVIEW_SCREEN = 'WEBVIEW_SCREEN';
export const INVALID_LINK_SCREEN = 'INVALID_LINK_SCREEN';
export const SHARE_DETAIL_SCREEN = 'SHARE_DETAIL_SCREEN';
export const TEXT_EDITOR_SCREEN = 'TEXT_EDITOR_SCREEN';
export const SHARING_SETTINGS_SCREEN = 'SHARING_SETTINGS_SCREEN';
export const VIDEO_RECORD_SCREEN = 'VIDEO_RECORD_SCREEN';

// FULL WEBVIEW
export const FULL_WEBVIEW_SCREEN = 'FULL_WEBVIEW_SCREEN';
export const MISC_WEBVIEW_SCREEN = 'MISC_WEBVIEW_SCREEN';
export const COURSES_WEBVIEW_SCREEN = 'COURSES_WEBVIEW_SCREEN';

// BLOCKPAGE WEBVIEW
export const BLOCKPAGE_WEBVIEW_SCREEN = 'BLOCKPAGE_WEBVIEW_SCREEN';
export const APP_WIDGET_WEBVIEW_SCREEN = 'APP_WIDGET_WEBVIEW_SCREEN';

// AUTH
export const SIGNUP_SCREEN = 'SIGNUP_SCREEN';
export const LOGIN_SCREEN = 'LOGIN_SCREEN';
export interface RouteLoginScreen extends OlRoutingAction {
  type: 'LOGIN_SCREEN';
}
export const FORGOT_SCREEN = 'FORGOT_SCREEN';
export const MICROSOFT_LOGIN_SCREEN = 'MICROSOFT_LOGIN_SCREEN';
export const ACCOUNT_LINKAGE_SCREEN = 'ACCOUNT_LINKAGE_SCREEN';
// AUTH LOADING
export const AUTH_LOADING_SCREEN = 'AUTH_LOADING_SCREEN';

// NOTIFICATION
export const UNREAD_NOTIFICATION_SCREEN = 'UNREAD_NOTIFICATION_SCREEN';
export const READ_NOTIFICATION_SCREEN = 'READ_NOTIFICATION_SCREEN';
export const NOTIFICATION_COURSE_ASSESSMENT_SCREEN =
  'NOTIFICATION_COURSE_ASSESSMENT_SCREEN';
export const NOTIFICATION_MAIN_SCREEN = 'NOTIFICATION_MAIN_SCREEN';
export const NOTIFICATION_SPINNER_SCREEN = 'NOTIFICATION_SPINNER_SCREEN';
export const NOTIFICATION_FEED_THREAD_SCREEN =
  'NOTIFICATION_FEED_THREAD_SCREEN';

// ALL NOTIFICATION
export const ALL_UNREAD_NOTIFICATION_SCREEN = 'ALL_UNREAD_NOTIFICATION_SCREEN';
export const ALL_READ_NOTIFICATION_SCREEN = 'ALL_READ_NOTIFICATION_SCREEN';
export const ALL_NOTIFICATION_COURSE_ASSESSMENT_SCREEN =
  'ALL_NOTIFICATION_COURSE_ASSESSMENT_SCREEN';
export const ALL_NOTIFICATION_MAIN_SCREEN = 'ALL_NOTIFICATION_MAIN_SCREEN';
export const ALL_NOTIFICATION_SPINNER_SCREEN =
  'ALL_NOTIFICATION_SPINNER_SCREEN';
export const ALL_NOTIFICATION_FEED_THREAD_SCREEN =
  'ALL_NOTIFICATION_FEED_THREAD_SCREEN';

// FEED
export const ACTIVITY_FEED_SCREEN = 'ACTIVITY_FEED_SCREEN';
export const POST_DETAILS_SCREEN = 'POST_DETAILS_SCREEN';
export const LIKERS_SCREEN = 'LIKERS_SCREEN';
export const FEED_MAIN_SCREEN = 'FEED_MAIN_SCREEN';

// COURSE
export const MY_COURSES_SCREEN = 'MY_COURSES_SCREEN';
export const COURSE_PROGRESS_SCREEN = 'COURSE_PROGRESS_SCREEN';

export interface RFRAction extends OlRoutingAction {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: any;
  meta?: { direction: string; resetStack?: boolean; backAmount?: number };
}

export interface MyDrawerStackScreen extends RFRAction {
  type: 'MY_DRAWER_STACK_SCREEN';
}
export interface PostDetailsScreen extends RFRAction {
  type: 'POST_DETAILS_SCREEN';
  query: {
    actionName?: string;
    actorId?: string;
    context?: ImMap<FeedItemContext>;
    timestamp?: string;
    coursePath?: string;
    sourcePath?: string;
    institutionName?: string;
    scrollToComment?: boolean;
    onActionOpenLink?: (uri: string) => void;
    enableCourseDashboardButton?: boolean;
  };
}
export interface LikersScreen extends RFRAction {
  type: 'LIKERS_SCREEN';
}

export interface BlockPageWebviewScreen extends RFRAction {
  type: 'BLOCKPAGE_WEBVIEW_SCREEN';
}

export interface AppWidgetWebviewScreen extends RFRAction {
  type: 'APP_WIDGET_WEBVIEW_SCREEN';
  query: {
    type: string;
    blockId: string;
    cohortPath: string | null;
    pageTitle: string | null;
    pagePath: string | null;
    coursePath: string | null;
    navigateToShareDetail: (shareType: ShareType, shareData: UserData) => void;
  };
}

export interface FullWebviewScreen extends RFRAction {
  type: 'FULL_WEBVIEW_SCREEN';
  query: {
    uri: string;
    coursePath: string;
    enableCourseDashboardButton: boolean;
  };
}

export interface InvalidLinkScreen extends RFRAction {
  type: 'INVALID_LINK_SCREEN';
  query: {
    clipboardContent: string;
  };
}

export interface ShareDetailScreen extends RFRAction {
  type: 'SHARE_DETAIL_SCREEN';
  query: {
    coursePath: string;
    blockId: string;
    pagePath: string;
    cohortPath: string;
    shareType: ShareType;
    shareData: ShareData | null;
    post?: ImPostMap;
  };
}

export interface RichTextEditorScreen extends RFRAction {
  type: 'TEXT_EDITOR_SCREEN';
  query: {
    appData: ShareTextWidgetAppData;
    navigateToShareDetail: (shareType: ShareType, shareData: ShareData) => void;
  };
}

export interface SharingSettingsScreen extends RFRAction {
  type: 'SHARING_SETTINGS_SCREEN';
  query: {
    postId?: string;
    blockId: string;
    coursePath: string;
  };
}

export interface FaceRecordScreen extends RFRAction {
  type: 'FACE_RECORD_SCREEN';
  query: {
    coursePath: string;
  };
}

export interface VideoRecordScreen extends RFRAction {
  type: 'VIDEO_RECORD_SCREEN';
  query: {
    navigateToShareDetail: (shareType: ShareType, shareData: ShareData) => void;
  };
}

export const CERTIFICATION_STATUS_SCREEN = 'CERTIFICATION_STATUS_SCREEN';
export const COURSE_OUTCOME_SCREEN = 'COURSE_OUTCOME_SCREEN';
export const COURSE_ASSESSMENT_SCREEN = 'COURSE_ASSESSMENT_SCREEN';
export const COURSE_DISCOVERY_SCREEN = 'COURSE_DISCOVERY_SCREEN';
export const FILTER_CATEGORY_SCREEN = 'FILTER_CATEGORY_SCREEN';
export const COURSE_LANDING_SCREEN = 'COURSE_LANDING_SCREEN';
export const COURSE_PRE_ENROLMENT_SCREEN = 'COURSE_PRE_ENROLMENT_SCREEN';
export const CHANGE_COURSE = 'CHANGE_COURSE';
export const FACE_RECORD_SCREEN = 'FACE_RECORD_SCREEN';

// MY FEED
export const MY_ACTIVITY_FEED_SCREEN = 'MY_ACTIVITY_FEED_SCREEN';
export const MY_FEED_MAIN_SCREEN = 'MY_FEED_MAIN_SCREEN';

// MISC
export const MISCELLANEOUS_SCREEN = 'MISCELLANEOUS_SCREEN';
export const EDIT_PROFILE_SCREEN = 'EDIT_PROFILE_SCREEN';

// DRAWER
export const DRAWER_SCREEN = 'DRAWER_SCREEN';
export const COURSE_POST_ENROLMENT_SCREEN = 'COURSE_POST_ENROLMENT_SCREEN';

export const ROUTE_COURSE_COHORT_ENDED = 'ROUTE_COURSE_COHORT_ENDED';

export type RouteInCourseWithQuery =
  | RouteCourseAdmin
  | RouteCohortAdmin
  | RouteCourseAssessment
  | RouteCourseCertification
  | RouteCourseProgress;

export type RouteInCourseWithPaginationQuery = RouteCourseAdminGeneral;

export type MobileRouteAction =
  | ShareDetailScreen
  | RichTextEditorScreen
  | FaceRecordScreen
  | MyDrawerStackScreen
  | PostDetailsScreen
  | LikersScreen
  | BlockPageWebviewScreen
  | FullWebviewScreen
  | SharingSettingsScreen
  | VideoRecordScreen
  | AppWidgetWebviewScreen
  | InvalidLinkScreen;

export type RouteAction =
  | RouteMyCoursePage
  | RouteCreateCoursePage
  | RouteCertificateVerificationPage
  | RouteInstitutionAdmin
  | RouteCreateInstitutionPage
  | RouteInstitutionHomepage
  | RouteContactPage
  | RouteHomepage
  | RoutePartnersListingPage
  | RouteCourses
  | RouteCoursePage
  | RouteInCourseWithQuery
  | RouteInCourseWithPaginationQuery
  | RouteWasabi
  | RouteSSO
  | RouteOther
  | RoutePaymentThankyouPage
  | RoutePaymentThankyouPage
  | RouteAccountSettings
  | RouteLoginScreen
  | MobileRouteAction
  | RouteUserProfilePage
  | RouteAccountsSubscriptions
  | RouteWasabiEditSubscription
  | RourteSamlCohortEntry;
